import React, { FC } from "react";
import { ConnectedProps, connect } from "react-redux";
import { IUhfViewState } from "../../pages/Contracts";
import { IRapComponentProperties } from "../../platform/Layout";

interface IUHFLoaderProvidedProps extends IRapComponentProperties {

}

interface IUHFLoaderOwnProps {

}

export type IUHFLoaderProps = ConnectedProps<typeof connector> & IUHFLoaderProvidedProps;

const UHFLoaderInitializer: FC<IUHFLoaderProps> = (props) => {
    return (
        //This is intentionally empty. We only want the header/footer to load, which is loaded outside the react app. 
        <></>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: IUHFLoaderProvidedProps): Partial<IUHFLoaderOwnProps> {
    return {
        ...providedProps,
    };
}

const ActionsToDispatch = {

};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const UHFLoader = connector(UHFLoaderInitializer);